<template>
	<div class="m-product" :style="{'border-radius': `${unitData.margin == 1 ? 6 : 0}px`, 'margin': `0 ${unitData.margin == 1 ? 12 : 0}px`, 'background-color': unitData.bg_color, 'background-image': `url('${unitData.bg_img}')`}">
		<div class="m-product-banner" :style="{'height': `${height}px`}">
			<div v-for="(item, i) in unitData.list" :key="i" class="item" :class="{'z-crt': i == 0}" :style="{'height': `${height}px`}">
				<a>
					<sub-image class="image" :src="item.img_url" mode="aspectFill" :style="{'width': `${width}px`, 'height': `${height}px`}"></sub-image>
				</a>
			</div>
			
			<div v-if="unitData.list && unitData.list.length > 1" class="nav">
				<div v-for="(item, i) in unitData.list" :key="i" class="item" :class="{'z-crt': i == 0}"></div>
			</div>
		</div>
		<div class="flex-column flex-center">
			<h1 v-if="title" class="m-product-title" :style="{'color': unitData.title_color}">{{unitData.list[0].title}}</h1>
			<div v-if="unitData.button_text" class="m-product-button" :style="{'border-color': unitData.button_color, 'color': unitData.button_color}">{{unitData.button_text}}</div>
		</div>
		<div class="m-product-list flex">
			<ul class="flex">
				<li v-for="(item, i) in unitData.product_list" :key="item.product_id">
					<sub-image class="image" :src="item.product_img_url"></sub-image>
					<p class="name ellipsis">￥{{item.product_name}}</p>
					<p v-if="unitData.is_point == 1" class="price">{{item.sale_price}}积分</p>
					<p v-else class="price">￥{{item.sale_price}}</p>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		},
		
		computed: {
			width() {
				return this.unitData.margin == 1 ? 363 : 369;
			},
			
			height() {
				if (this.unitData.list && this.unitData.list[0]) {
					return this.unitData.list[0].img_height / 2 * this.width / 375;
				}
				
				return this.width;
			},
			
			title() {
				return this.unitData.list && this.unitData.list.find(item => item.title);
			}
		},
		
		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.m-product {
		padding: 12px;
		margin: 0 12px;
		overflow: hidden;
		background-color: #fff;
		background-size: 100% auto;
		background-repeat: no-repeat;
		
		&-banner {
			position: relative;
			overflow: hidden;
			
			> .item {
				position: absolute;
				left: 0;
				right: 0;
				top: 0;
				text-align: center;
				opacity: 0;
				transition: opacity .3s ease;
				
				&.z-crt {
					z-index: 1;
					opacity: 1;
				}
			}
			
			.nav {
				z-index: 1;
				position: absolute;
				left: 50%;
				bottom: 15px;
				font-size: 0;
				transform: translate(-50%,0);
				
				.item {
					display: inline-block;
					width: 5px;
					height: 5px;
					border-radius: 50%;
					margin: 0 8px;
					background: rgba(0,0,0,.3);
					
					&.z-crt {
						background: #000;
					}
				}
			}
		}
		
		&-title {
			height: 1em;
			margin-top: 20px;
			font-size: 16px;
		}
		
		&-button {
			box-sizing: border-box;
			min-width: 120px;
			border: 1px solid #000;
			padding: 0 30px;
			margin-top: 20px;
			line-height: 40px;
			font-size: 14px;
			text-align: center;
			color: #000;
			background: #fff;
		}
		
		&-list {
			margin-top: 30px;
			overflow: hidden;
			
			ul {
				float: left;
				
				li {
					width: 140px;
					padding-bottom: 5px;
					
					&:nth-child(n+2) {
						margin-left: 10px;
					}
					
					.image {
						height: 140px;
					}
					
					.name {
						line-height: 36px;
						font-size: 14px;
						text-align: center;
					}
					
					.price {
						font-size: 14px;
						text-align: center;
					}
				}
			}
		}
	}
</style>
